import { t } from 'ttag'
import styled from 'styled-components'
import { useEffect } from 'react'

import { FilterGrid } from '@h2/common/components/filterGrid'
import { useForm } from '@h2/common/components/hooks/useForm'
import { TextInput } from '@h2/components/inputs/text'
import { Field } from '@h2/components/inputs/field'
import { Flex } from '@h2/components/layout/flex'
import { gap } from '@h2/common/components/page'
import { Button } from '@h2/components/buttons/button'

const FlexField = styled(Field)`
  flex: 1;
`
const Form = styled.form`
  width: 100%;
`
const GroupFilterGrid = ({ routeColor, isFetching, filter }) => {
  const { register, isInvalid, handleOnSubmit, dispatch, error } = useForm()
  const filterData = filter.getData[filter.key]

  useEffect(() => {
    dispatch({
      type: 'update',
      payload: {
        ...filterData
      }
    })
  }, [dispatch, filterData])

  const updateFilters = form => {
    const { term } = form
    const toSubmit = {
      term
    }

    filter.setData({
      ...filter.getData,
      [filter.key]: toSubmit
    })
  }

  return (
    <FilterGrid bgColor={routeColor}>
      <Form onSubmit={handleOnSubmit(form => updateFilters(form))}>
        <Flex gap={gap}>
          <FlexField desc={error.term} status={error.term ? 'error' : 'default'}>
            <TextInput placeholder={t`Search Term`} {...register('term')} />
          </FlexField>
          <Button
            style={{ flex: '1' }}
            type="submit"
            align="center"
            isLoading={isFetching}
            isDisabled={isFetching || isInvalid}>
            {t`Update`}
          </Button>
        </Flex>
      </Form>
    </FilterGrid>
  )
}

export { GroupFilterGrid }
